import { render, staticRenderFns } from "./ListaAbonos.vue?vue&type=template&id=bd6b750c"
import script from "./ListaAbonos.vue?vue&type=script&lang=js"
export * from "./ListaAbonos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports